export default "__VITE_ASSET__Bxcxrsq8__"